import { render, staticRenderFns } from "./delivery_failures.vue?vue&type=template&id=4c64f001&scoped=true&"
import script from "./delivery_failures.vue?vue&type=script&lang=js&"
export * from "./delivery_failures.vue?vue&type=script&lang=js&"
import style0 from "./delivery_failures.vue?vue&type=style&index=0&id=4c64f001&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c64f001",
  null
  
)

export default component.exports